'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wlLogo = require('../../../img/wlLogo.png');

var _wlLogo2 = _interopRequireDefault(_wlLogo);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkUserComponent = function (_React$Component) {
    _inherits(LinkUserComponent, _React$Component);

    function LinkUserComponent(props, context) {
        _classCallCheck(this, LinkUserComponent);

        var _this = _possibleConstructorReturn(this, (LinkUserComponent.__proto__ || Object.getPrototypeOf(LinkUserComponent)).call(this, props, context));

        _this.linkUser = function (e) {
            e.preventDefault();

            Utils.showSpinner();

            _this.linkToUserWithEmailAccount(_this.lpassword.value);
        };

        _this.cancelLinking = function () {
            var router = _this.props.history;
            var locId = _this.props.locId;
            _this.props.callbackParent(true);
            Utils.logOutAll(router, locId, false);
        };

        _this.redirectToForgotPassword = function () {
            var router = _this.props.history;
            var locId = _this.props.locId;

            _this.props.showForgotPasswordBox();
            Utils.logOutAll(router, locId, false);
        };

        _this.state = {
            error: _this.props.message,
            isProcessActive: false
        };
        return _this;
    }

    _createClass(LinkUserComponent, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.lpassword.focus();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'linkToUserWithEmailAccount',
        value: function linkToUserWithEmailAccount(passwd) {
            var self = this;
            var authUser = this.props.userFromAuthProviderLogin;
            var email = authUser.get("email");
            var authData = authUser.get("authData");
            var authType = this.props.authType;
            var router = this.props.history;
            var locId = this.props.locId;

            if (!authUser) {
                Utils.hideSpinner();
                console.log('Error: linkToUserWithEmailAccount() userFromAuthProviderLogin must NOT be null. email: ' + email + ' authType:' + authType);
                Utils.logOutAll(router, locId, false);
                this.setState({
                    error: email + ' account could not be linked.'
                });
                return;
            }

            authUser.destroy().then(function (destroyedUser) {
                // console.log(JSON.stringify(destroyedUser));
                Utils.logOut(router, locId, false);
            }).then(function () {
                return _parse2.default.User.logIn(email, passwd);
            }).then(function (user) {
                var result = void 0;
                switch (authType) {
                    case "facebook":
                        result = _parse2.default.FacebookUtils.link(user, null, {});
                        break;
                    case "google":
                        var aDWrapper = {
                            authData: authData.google
                        };
                        result = user._linkWith(provider, aDWrapper);
                        break;
                    default:
                        result = _parse2.default.Promise.error("Error: Invalid authType:" + authType);
                }
                return result;
            }).then(function (user) {

                Utils.hideSpinner();
                self.setState({
                    error: null,
                    isProcessActive: false
                });
                self.props.informLinkStatus(user);
            }).then(function () {
                Utils.updateUserAcl();
            }, function (error) {
                console.log(JSON.stringify(error));
                Utils.hideSpinner();
                Utils.logOutAll(router, locId, false);
                self.setState({
                    error: email + ' account could not be linked.',
                    isProcessActive: false
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { id: 'linkuser-box', className: 'mainbox col-md-12 col-sm-12' },
                _react2.default.createElement(
                    'div',
                    { className: 'row', style: { marginTop: 20, marginBottom: 30 } },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-4 offset-1' },
                        _react2.default.createElement('img', {
                            className: 'img-responsive center-block',
                            alt: 'FreshBytes',
                            title: 'FreshBytes',
                            src: this.props.userPic,
                            style: { height: 66 }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-2 text-center' },
                        _react2.default.createElement('i', { className: 'fa fa-long-arrow-right fa-2x', 'aria-hidden': 'true', style: { marginTop: 5 } })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-4' },
                        _react2.default.createElement('img', {
                            className: 'img-responsive center-block',
                            alt: 'FreshBytes',
                            title: 'FreshBytes',
                            src: _wlLogo2.default
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'panel' },
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-body' },
                        this.state.error ? _react2.default.createElement(
                            'div',
                            { id: 'forgotpass-alert', className: 'alert alert-danger col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row centered errors', style: { marginLeft: 5 } },
                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-remove' }),
                                ' ',
                                this.state.error
                            )
                        ) : null,
                        _react2.default.createElement(
                            'form',
                            { id: 'linkUserform', className: 'form-horizontal', onSubmit: this.linkUser, role: 'form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group mb-1' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'inputPassword', className: 'mb-1' },
                                    'Password'
                                ),
                                _react2.default.createElement('input', {
                                    type: 'password',
                                    id: 'login-password',
                                    name: 'password',
                                    placeholder: 'Password',
                                    ref: function ref(input) {
                                        return _this2.lpassword = input;
                                    },
                                    className: "rounded-sm form-control",
                                    required: true
                                })
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    className: "btn btn-lg rounded-sm custom-btn-outline-primary btn-block btn-login text-uppercase font-weight-bold mt-3 mb-2",
                                    onClick: this.linkUser },
                                'Connect'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center pt-3' },
                            _react2.default.createElement(
                                'a',
                                { onClick: this.cancelLinking, className: 'cursor-pointer' },
                                _react2.default.createElement(
                                    'span',
                                    {
                                        className: 'text-danger ft-14' },
                                    'I don\'t want to link'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center pt-2 ft-14 cursor-pointer' },
                            _react2.default.createElement(
                                'a',
                                { onClick: this.redirectToForgotPassword },
                                'Forgot password?'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return LinkUserComponent;
}(_react2.default.Component);

exports.default = LinkUserComponent;


LinkUserComponent.contextTypes = {
    router: _propTypes2.default.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/login/LinkUser.jsx
// module id = 539
// module chunks = 0